/**
 * GENERATED_ASSET — recipe constants for the adapter (no JSON import, so any bundler works).
 * The schema alongside this module documents the editable recipe envelope.
 */
import type { FountainRecipe, FountainVariant } from './types';

const base = {
  schema: 'hush.asset-recipe.v1', assetId: 'prop.coastal.tidal_cascade_fountain',
  generatorId: 'scenery.tidal_cascade_fountain.v1', paletteId: 'coastal_salt', detail: 'standard',
} as const;

export const FOUNTAIN_RECIPES: Readonly<Record<FountainVariant, FountainRecipe>> = {
  harbor: {
    ...base, id: 'coastal.tidal_cascade_fountain.harbor.v1', seed: 21021,
    params: { variant: 'harbor', width: 384, height: 320, tiers: 3, flow: 0.55, waterLevel: 0.6, mossCoverage: 0.18, stoneWear: 0.35 },
  },
  mossgrown: {
    ...base, id: 'coastal.tidal_cascade_fountain.mossgrown.v1', seed: 21022,
    params: { variant: 'mossgrown', width: 384, height: 320, tiers: 3, flow: 0.4, waterLevel: 0.72, mossCoverage: 0.42, stoneWear: 0.45 },
  },
  dry_ruin: {
    ...base, id: 'coastal.tidal_cascade_fountain.dry_ruin.v1', seed: 21023,
    params: { variant: 'dry_ruin', width: 384, height: 320, tiers: 2, flow: 0, waterLevel: 0.12, mossCoverage: 0.3, stoneWear: 0.6 },
  },
};
